import { createContext, type PropsWithChildren, useContext } from "react";

const CareerScoutOpenContext = createContext(false);

export function CareerScoutOpenProvider({ open, children }: PropsWithChildren<{ open: boolean }>) {
  return <CareerScoutOpenContext.Provider value={open}>{children}</CareerScoutOpenContext.Provider>;
}

export function useCareerScoutOpen(): boolean {
  return useContext(CareerScoutOpenContext);
}
